import React from "react";
import {observer} from "mobx-react";
import PropTypes from "prop-types";
import useField from "../hooks/use-field";

function Hidden(props) {

    const {
        id,
        name,
        value,
    } = useField(props);

    return <input id={id}
                  name={name}
                  type={"hidden"}
                  value={value}/>;
}

Hidden.defaultProps = {
    defaultValue: null,
}

Hidden.propTypes = {
    name: PropTypes.string.isRequired,
    defaultValue: PropTypes.any,
}

export default observer(Hidden);
